import styled from "styled-components";
import { TextField as MuiTextField } from "@mui/material";

export const LengthMinDiv = styled.div`
    font-size: 14px;
    color: ${({ theme }) => theme.colors.GREY_EXTRA_HEAVY};
`;

export const LengthMinInput = styled(MuiTextField)`
    div {
        font-size: 14px;
        height: 10px;
        background-color: #f7f9fd;
        padding: 10px 10px;
        margin: -2px 5px;
        border-radius: 6px;
        margin-bottom: 24px;
        width: 50px;

        &::before {
            border-bottom: ${({ theme }) => `0px solid ${theme.colors.GREY_HEAVY}`} !important;
        }

        &::after {
            border-bottom: ${({ theme }) => `2px solid ${theme.colors.BLUE_HEAVY}`};
        }

        /* Webkit 브라우저(Chrome, Safari)에서 스핀 버튼 숨기기 */
        input::-webkit-inner-spin-button,
        input::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Firefox에서 스핀 버튼 숨기기 */
        input[type="number"] {
            -moz-appearance: textfield;
        }
    }
`;
